// extracted by mini-css-extract-plugin
export var cartContainer = "_p0-4";
export var gray = "_p0-1";
export var itemContainer = "_p0-2";
export var itemDetails = "_p0-3";
export var strong = "_p0-0";